import { render, staticRenderFns } from "./SellerBarComparisonChart.vue?vue&type=template&id=df312536&"
import script from "./SellerBarComparisonChart.vue?vue&type=script&lang=ts&"
export * from "./SellerBarComparisonChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports